import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';

dayjs.extend(buddhistEra);
dayjs.locale('th');

export const formatCurrency = (amount) =>
  new Intl.NumberFormat('th-TH', {
    style: 'currency',
    currency: 'THB',
    minimumFractionDigits: 0,
  }).format(amount || 0);

export const monthLabel = (year, month) => dayjs().year(year).month(month - 1).format('MMMM BBBB');

// บาง record ชื่อ (firstname) ดันมีคำนำหน้าติดมาด้วยในข้อมูลดิบ (เช่น "นายสมชาย" แทนที่จะเป็น
// "สมชาย" เฉยๆ) — ตัดคำนำหน้าที่ติดมากับ firstname ออกก่อนแสดงผล/ก่อนต่อกับ title ที่แยกคอลัมน์อยู่
// แล้ว (เช็ค "นางสาว" ก่อน "นาง" เพราะ "นางสาว" ขึ้นต้นด้วย "นาง") — มี logic เดียวกันฝั่ง backend
// ที่ backend/helpers/ssoExportExcel.helper.js (สร้างไฟล์ .xlsx จริง) อย่าลืมแก้คู่กันถ้าต้องปรับ
const TITLE_PREFIXES = ['นางสาว', 'นาง', 'นาย'];
export const stripEmbeddedTitle = (name = '') => {
  const trimmed = (name || '').trim();
  const prefix = TITLE_PREFIXES.find((t) => trimmed.startsWith(t));
  return prefix ? trimmed.slice(prefix.length).trim() : trimmed;
};

export function getPeriodSlots(periodsFound) {
  const hasFirstDaily = periodsFound.some(
    (p) => p.role_type === 'DAILY' && dayjs(p.dateStart).date() <= 15
  );
  const hasSecondDaily = periodsFound.some(
    (p) => p.role_type === 'DAILY' && dayjs(p.dateStart).date() > 15
  );
  const hasFulltime = periodsFound.some((p) => p.role_type === 'FULLTIME');
  return { first: hasFirstDaily, second: hasSecondDaily, fulltime: hasFulltime };
}

// สรุปตัวเลขสำหรับแถบ stat บนสุดของ modal — คิดจากผลลัพธ์ getMonthDetail ที่ fetch มาแล้ว (ไม่มี fetch เพิ่ม)
export function computeSummaryStats(data) {
  const paidRows = [...data.daily, ...data.fulltime];
  const totalAmount = paidRows.reduce((sum, r) => sum + (r.total || 0), 0);
  const missingIdCount = [...paidRows, ...data.noPay].filter((r) => !r.has_id_card).length;
  return {
    totalPeople: paidRows.length,
    totalAmount,
    noPayCount: data.noPay.length,
    missingIdCount,
  };
}
